<template>
  <div>
    <!-- Snackbar -->
    <v-snackbar v-model="snackbar" top :color="color" :timeout="6000">
      <span v-if="snackbar_msg">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>

    <v-card>
      <div><v-toolbar flat dense class="toolbar">
          <v-toolbar-title>Student Late-In/Early-Out---</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>

          <v-div><v-btn class="button" @click="openDialogAddStudent()">Add Student</v-btn>
          </v-div>

        </v-toolbar>
      </div>


      <v-card-text>
        <!-- Date Picker -->
        <v-row justify="center" class="mt-2">
          <v-col cols="12" sm="6" md="3">
            <v-text-field v-model="selected_from_date" rounded dense outlined type="date">
              <template #label>
                Date<span style="color: red;">*</span>
              </template>
            </v-text-field>
          </v-col>
        </v-row>

        <!-- Filter Type Radio Buttons -->
        <v-row justify="center" align="center">
          <v-col cols="12" sm="3" md="4"></v-col>
          <v-col cols="12" sm="3" md="6">
            <v-radio-group v-model="filterType" row>
              <v-radio label="Late-In" value="late" class="radio-bold"></v-radio>
              <v-radio label="Early-Out" value="early" class="radio-bold"></v-radio>
            </v-radio-group>
          </v-col>
        </v-row>

        <!-- Fetch Button -->
        <v-row justify="center" align="center" class="mt-3">
          <v-btn rounded class="button mr-2" :loading="loader" @click="getAllReport">
            Fetch
          </v-btn>
        </v-row>
      </v-card-text>

      <!-- Data Table -->
      <div id="my-table-id" class="ma-3" v-if="attendanceList.length">
        <v-toolbar flat dense class="toolbar">
          <v-toolbar-title>Student Late-In/Early-Out</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>


          <v-text-field class="pr-5" background-color="white" v-model="search" append-icon="mdi-magnify"
            label="Search by Student Name or Registration Number" single-line hide-details></v-text-field>

          <v-btn small class="mr-5" color="success" @click="generateAttendancePdf" :loading="loader">
            <v-icon small color="white">mdi-file-pdf-box</v-icon>
            <span class="btn-text">PDF</span>
          </v-btn>
          <v-btn small color="success" @click="exportAttendanceData" :loading="loader">
            <v-icon small color="white">mdi-export</v-icon>
            <span class="btn-text">Export</span>
          </v-btn>

        </v-toolbar>

        <v-data-table class="elevation-1 mytable" :headers="computedHeaders" :items="filteredAttendanceList"
          :items-per-page="10" dense>
          <template v-slot:item="{ item }">
            <tr>
              <td>
                <span>
                  <v-avatar style="" size="25" class="edit-avatar">
                    <v-icon class="edit-v-icon mr-2" @click="openeditdialog(item)">edit</v-icon>
                  </v-avatar>
                </span>
                <span>
                  <v-icon icon class="delete-quick-link-btn" style="color: red;" title="Delete "
                    @click="deletestudentlateiamdearlyout(item.id)">delete</v-icon>
                </span>
              </td>
              <td>{{ item.srno }}</td>
              <td>{{ item.prn }}</td>
              <td>{{ item.student_name }}</td>
              <td>{{ item.standard }}</td>
              <td>{{ item.division }}</td>
              <td>{{ item.mapped_route }}</td>
              <td>{{ item.currentvehicle }}</td>

              <td>
                <span v-if="filterType === 'late' && item.late_in">Late-In</span>
                <span v-else-if="filterType === 'early' && item.early_out">Early-Out</span>
                <span v-else>--</span>
              </td>
              <td v-if="filterType === 'late'">{{ item.in_time ? formatTime(item.in_time) : '--' }}</td>
              <td v-if="filterType === 'late'">{{ item.in_remark || '--' }}</td>
              <td v-if="filterType === 'early'">{{ item.out_time ? formatTime(item.out_time) : '--' }}</td>
              <td v-if="filterType === 'early'">{{ item.out_remark || '--' }}</td>

            </tr>
          </template>
        </v-data-table>
      </div>


      <!-- No Data Found -->
      <div v-else class="ma-3 text-center">
        <div class="center-screen">
          <v-img class="img-size" :src="require('@/assets/no_data_found.jpg')" alt="No Data Found" contain></v-img>
        </div>
      </div>
    </v-card>
    <v-dialog v-model="dialogAddStudent" width="1000px" persistent>
      <v-card>

        <v-col cols="12" sm="12" md="12">
          <v-card class="box">
            <v-toolbar class="toolbar" flat dense>
              <v-btn icon dark @click="dialogAddStudent = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <v-toolbar-title>Add Student Late-In/Early-Out</v-toolbar-title>
            </v-toolbar>
            <v-row justify="center" align="center" class="mt-5">
              <!-- <v-col cols="12" sm="3" md="1"></v-col> -->
              <v-col cols="12" sm="3" md="4">


                <v-autocomplete rounded dense required v-model="selectedLearnerId" :items="learner_list"
                  item-text="name" @change="getLearnerDetails" item-value="id" label="Please Select Student" outlined
                  persistent-hint hint="Please Select Student"><template #label>
                    Please Select Student<span style="color: red;">*</span>
                  </template></v-autocomplete>

              </v-col>
            </v-row>
            <v-row justify="center" class="mt-2">
              <v-simple-table dense fixed-header class="elevation-1 bordered-table">
                <thead>
                  <tr>
                    <th>Prn</th>
                    <th>Student Name</th>
                    <th>Standard</th>
                    <th>Division</th>
                    <th>Route No</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in learner_details" :key="index">
                    <td>{{ item.prn }}</td>
                    <td>{{ item.student_name }}</td>
                    <td>{{ item.standard }}</td>
                    <td>{{ item.division }}</td>
                    <td>{{ item.route_no }}</td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-row>

            <!-- Date Picker -->
            <v-row justify="center" class="mt-4">
              <!-- <v-col cols="12" sm="3" md="1"></v-col>  -->
              <v-col cols="12" sm="6" md="4">
                <v-text-field v-model="selected_from_date_save" rounded outlined dense type="date">
                  <template #label>
                    Date<span style="color: red;">*</span>
                  </template>
                </v-text-field>
              </v-col>
            </v-row>

            <!-- Filter Type Radio Buttons -->
            <v-row justify="center" align="center">
              <v-col cols="12" sm="3" md="3"></v-col>
              <v-col cols="12" sm="3" md="7">
                <v-span>
                  <b>Movement Type</b><span style="color: red;">*</span>
                </v-span>
                <v-radio-group v-model="filterTypeforsave" row>
                  <v-radio label="Late-In" value="late" class="radio-bold"></v-radio>
                  <v-radio label="Early-Out" value="early" class="radio-bold"></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
            <v-row justify="center" align="center" class="mt-5">
              <v-col cols="12" sm="3" md="4">
                <v-text-field rounded dense required v-model="time" type="time" label="Please Select Time" outlined
                  persistent-hint hint="Please Select Time"><template #label>
                    Time<span style="color: red;">*</span>
                  </template></v-text-field>

              </v-col>
            </v-row>
            <v-row justify="center" align="center">
              <v-col cols="12" sm="3" md="1"></v-col>
              <v-col cols="12" sm="3" md="5">
                <v-span>
                  <b>Enter Remark<span style="color:red">*</span></b>
                </v-span>
                <v-textarea outlined v-model="remark"></v-textarea>


              </v-col>
            </v-row>
            <v-row justify="center" class="mt-3">
              <v-btn rounded color="primary" :loading="loader" @click="saveStudentAttendance">
                Save
              </v-btn>
            </v-row>

          </v-card>
        </v-col>
      </v-card>
    </v-dialog>
    <v-dialog v-model="edit_dialog" width="1000px" persistent>
      <v-card>

        <v-col cols="12" sm="12" md="12">
          <v-card class="box">
            <v-toolbar class="toolbar" flat dense>
              <v-btn icon dark @click="edit_dialog = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <v-toolbar-title>Edit Student Late-In/Early-Out</v-toolbar-title>
            </v-toolbar>

            <v-row justify="center" align="center" class="mt-5">
              <v-col cols="12" sm="3" md="4">
                <v-text-field rounded dense required v-model="edit_time" type="time" label="Please Select Time" outlined
                  persistent-hint hint="Please Select Time"><template #label>
                    Time<span style="color: red;">*</span>
                  </template></v-text-field>

              </v-col>
            </v-row>
            <v-row justify="center" align="center">
              <v-col cols="12" sm="3" md="1"></v-col>
              <v-col cols="12" sm="3" md="5">
                <v-span>
                  <b>Enter Remark<span style="color:red">*</span></b>
                </v-span>
                <v-textarea outlined v-model="edit_remark"></v-textarea>


              </v-col>
            </v-row>
            <v-row justify="center" class="mt-3">
              <v-btn rounded color="primary" :loading="loader" @click="editStudentAttendance">
                Save
              </v-btn>
            </v-row>

          </v-card>
        </v-col>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import axios from "axios";
  import "@/assets/css/color.css";
  import jsPDF from "jspdf";
  import "jspdf-autotable";

  export default {
    data() {
      return {
        loader: false,
        dialogAddStudent: false,
        edit_dialog: false,
        time: '',
        tla_id: null,
        edit_time: '',
        edit_remark: null,
        color: "",
        snackbar: false,
        snackbar_msg: null,
        selected_from_date: new Date().toISOString().slice(0, 10),
        selected_from_date_save: new Date().toISOString().slice(0, 10),
        filterType: "late", // default to Late-In
        filterTypeforsave: "late",
        remark: null,
        search: null,
        selectedLearnerId: null,
        learner_list: [],
        learner_details: [],
        attendanceList: [],
      };
    },

    mounted() {
      const now = new Date();
      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');
      this.time = `${hours}:${minutes}`; // ✅ set current time by default  
      this.onload();
    },

    computed: {
      // Table headers change dynamically based on radio
      computedHeaders() {
        let headers = [
          { text: "Action", value: "edit" },
          { text: "Sr No", value: "srno" },
          { text: "PRN", value: "prn" },
          { text: "Student Name", value: "student_name" },
          { text: "Standard", value: "standard" },
          { text: "Division", value: "division" },
          { text: "Mapped Route", value: "mapped_route" },
          { text: "Vehicle No", value: "currentvehicle" },


        ];

        if (this.filterType === "late") {
          headers.push({ text: "Type", value: "type" });
          headers.push({ text: "In Time", value: "in_time" });
          headers.push({ text: "In Remark", value: "in_remark" });
        } else if (this.filterType === "early") {
          headers.push({ text: "Type", value: "type" });
          headers.push({ text: "Out Time", value: "out_time" });
          headers.push({ text: "Out Remark", value: "out_remark" });
        }

        return headers;
      },

      filteredAttendanceList() {
        let list = this.attendanceList;

        // Filter by radio (Late-In / Early-Out)
        if (this.filterType === "late") {
          list = list.filter((x) => x.late_in);
        } else if (this.filterType === "early") {
          list = list.filter((x) => x.early_out);
        }

        // Search filter
        if (this.search) {
          const searchLower = this.search.toLowerCase();
          list = list.filter(
            (item) =>
              (item.prn && item.prn.toLowerCase().includes(searchLower)) ||
              (item.student_name && item.student_name.toLowerCase().includes(searchLower))
          );
        }

        // Always return an array, even if empty
        return list;
      }


    },

    methods: {
      generateAttendancePdf() {
        if (!this.filteredAttendanceList.length) {
          this.showSnackbar("error", "No data available for PDF");
          return;
        }

        const headers = this.computedHeaders.filter(h => h.value !== 'edit');
        const data = this.filteredAttendanceList;

        const exportData = data.map((item, index) => {
          const row = {};
          headers.forEach(h => {
            if (h.value === 'srno') {
              row[h.text] = index + 1;
            } else if (h.value === 'type') {
              row[h.text] = this.filterType === 'late' ? 'Late-In' : 'Early-Out';
            } else if (h.value === 'in_time' || h.value === 'out_time') {
              row[h.text] = item[h.value]
                ? new Date(item[h.value]).toLocaleTimeString("en-US", {
                  hour: "2-digit",
                  minute: "2-digit",
                  hour12: true
                })
                : '--';
            } else {
              row[h.text] = (item[h.value] != null) ? item[h.value] : '--';
            }
          });
          return row;
        });

        const doc = new jsPDF({ orientation: "landscape", unit: "mm", format: "a4" });

        const columns = headers.map(h => ({ header: h.text, dataKey: h.text }));

        const columnStyles = {
          "Sr No": { cellWidth: 19 },
          "PRN": { cellWidth: 30 },
          "Student Name": { cellWidth: 38 },
          "Standard": { cellWidth: 25 },
          "Division": { cellWidth: 25 },
          "Mapped Route": { cellWidth: 25 },
          "Vehicle No": { cellWidth: 25 },
          "Type": { cellWidth: 25 },
        };

        if (this.filterType === 'late') {
          columnStyles["In Time"] = { cellWidth: 25 };
          columnStyles["In Remark"] = { cellWidth: 30 };
        } else {
          columnStyles["Out Time"] = { cellWidth: 25 };
          columnStyles["Out Remark"] = { cellWidth: 30 };
        }

        doc.setFontSize(14);
        doc.text(`${this.filterType === 'late' ? 'Late-In' : 'Early-Out'} Report - ${this.selected_from_date}`, 14, 15);

        doc.autoTable({
          theme: "grid",
          columns,
          body: exportData,
          startY: 25,
          styles: { fontSize: 7, cellPadding: 1, overflow: "linebreak" },
          headStyles: { fillColor: [0, 100, 0], textColor: [255, 255, 255], fontSize: 8 },
          columnStyles,
        });

        doc.save(this.filterType === 'late' ? 'Late_In_Report.pdf' : 'Early_Out_Report.pdf');
      },


      exportAttendanceData() {
        try {
          // Step 1: Get headers from computedHeaders
          let headers = this.computedHeaders;

          // Step 2: Remove "Action" column from export (but keep in table)
          const exportHeaders = headers.filter(h => h.value !== "edit");

          const headerTexts = exportHeaders.map(h => h.text);

          // Step 3: Use filtered list
          const data = this.filteredAttendanceList;

          const rows = data.map((item, idx) => {
            const row = {};

            exportHeaders.forEach(h => {
              const key = h.value;
              const label = h.text;

              if (key === "srno") {
                row[label] = idx + 1;
              }
              else if (key === "in_time" || key === "out_time") {
                row[label] = item[key]
                  ? new Date(item[key]).toLocaleTimeString("en-US", {
                    hour: "2-digit",
                    minute: "2-digit",
                    hour12: true
                  })
                  : "-";
              }
              else if (key === "type") {
                row[label] = this.filterType === "late" ? "Late-In" : "Early-Out";
              }
              else {
                row[label] = (item[key] !== undefined && item[key] !== null) ? item[key] : "-";
              }
            });

            return row;
          });

          // Step 4: Export using filtered headers
          import("xlsx").then(XLSX => {
            const ws = XLSX.utils.json_to_sheet(rows, { header: headerTexts });
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, "Attendance");

            const fileName = this.filterType === "late"
              ? "Late_In_List.xlsx"
              : "Early_Out_List.xlsx";

            XLSX.writeFile(wb, fileName);
          });

        } catch (err) {
          console.error("Export error:", err);
          this.showSnackbar("error", "Failed to export data");
        }
      },
      async editStudentAttendance() {
        const payload = {
          id: this.tla_id,
          remark: this.edit_remark,
          time: this.edit_time,
          type: this.filterType
        };

        try {
          const res = await axios.post('/TransportLearnerAttendance/editStudentLateInEarlyOut', payload);

          if (res.data.flag === "YES") {
            this.edit_dialog = false;
            this.getAllReport();
            this.showSnackbar("green", res.data.msg);
          } else {
            this.showSnackbar("red", "Something went wrong!");
          }
        } catch (error) {
          console.error("Edit API Error:", error);
          this.showSnackbar("red", "Error while saving attendance!");
        }
      },

      openeditdialog(item) {
        this.tla_id = item.id,
          this.edit_remark = null
        this.edit_dialog = true;

        if (this.filterType === "late") {
          this.edit_remark = item.in_remark;
          this.edit_time = this.formatTime1(item.in_time);
        }
        if (this.filterType === "early") {
          this.edit_remark = item.out_remark;
          this.edit_time = this.formatTime1(item.out_time);
        }
      },
      async saveStudentAttendance() {

        // Basic validation
        if (!this.selected_from_date_save) {
          this.showSnackbar("error", "Please select a date")
          return
        }

        if (!this.remark || !this.remark.trim()) {
          this.showSnackbar("error", "Please enter a remark")
          return
        }

        // Prepare payload
        const payload = {
          learner: this.selectedLearnerId,  // Make sure you set this when selecting a student
          selected_from_date: this.selected_from_date_save,
          type: this.filterTypeforsave === 'late' ? 'Late' : 'Early',
          remark: this.remark,
          time: this.time
        }

        try {
          this.loader = true
          const res = await axios.post("/TransportLearnerAttendance/saveStudentLateInEarlyOut", payload)

          if (res.data.flag === "YES") {
            this.showSnackbar("success", res.data.snackbar || "Attendance saved successfully")
            this.dialogAddStudent = false

            // Reset form
            this.remark = null
            this.filterTypeforsave = 'late'
            this.selected_from_date_save = new Date().toISOString().slice(0, 10)

            // Refresh the table
            this.getAllReport()
          } else {
            this.showSnackbar("error", res.data.msg || "Failed to save attendance")
          }
        } catch (err) {
          this.showSnackbar("error", "Error saving attendance")
        } finally {
          this.loader = false
        }
      },
      async deletestudentlateiamdearlyout(id) {
        const payload = { id: id };

        try {
          const res = await axios.post("/TransportLearnerAttendance/deleteStudentLateInEarlyOut", payload);

          if (res.data.flag === "YES") {
            // Refresh the table
            this.getAllReport();
            this.showSnackbar("green", res.data.msg);
          } else {
            this.showSnackbar("red", "Something went wrong!");
          }
        } catch (error) {
          console.error("Error deleting record:", error);
          this.showSnackbar("red", "Server error while deleting record!");
        }
      },

      openDialogAddStudent() {
        this.dialogAddStudent = true;
      },




      showSnackbar(color, msg) {
        this.snackbar = true;
        this.color = color;
        this.snackbar_msg = msg;
      },

      async onload() {
        try {
          const res = await axios.post("/TransportLearnerAttendance/getLearnerlist");
          if (res.data.msg === "200") {
            this.learner_list = res.data.learner_list;
            this.selectedLearnerId = this.learner_list[0].id;
            if (this.selectedLearnerId) {
              this.getLearnerDetails()
            }
          } else {
            this.showSnackbar("error", res.data.msg || "Failed to load data");
          }

        } catch {
          this.showSnackbar("error", "Error loading learner list");
        }
      },
      async getLearnerDetails() {
        this.attendanceList = [];
        const payload = { learnerId: this.selectedLearnerId };
        const res = await axios.post("/TransportLearnerAttendance/getLearnerDetails", payload);
        if (res.data.msg === "200") {
          this.learner_details = res.data.learner_details;

        } else {
          this.showSnackbar("error", res.data.msg || "Failed to load data");
        }


      },

      async getAllReport() {
        this.loader = true;
        this.attendanceList = [];
        const payload = { selected_from_date: this.selected_from_date };
        try {
          const res = await axios.post("/TransportLearnerAttendance/getStudentLateInEarlyOut", payload);
          if (res.data.msg === "200") this.attendanceList = res.data.attendanceList;
          else this.showSnackbar("error", res.data.msg || "Failed to fetch report");
        } catch {
          this.showSnackbar("error", "Error fetching report");
        } finally {
          this.loader = false;
        }
      },

      formatTime(value) {
        if (!value) return "--";
        const date = new Date(value);
        return date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", hour12: true });
      },
      // Helper function to format time
      formatTime1(datetime) {
        if (!datetime) return null;
        const date = new Date(datetime);
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        return `${hours}:${minutes}`;
      },
    },
  }

</script>

<style scoped>
  .bordered-table {
    border-collapse: collapse;
    /* Ensures borders are not doubled */
    width: 500px;
  }

  .bordered-table th,
  .bordered-table td {
    border: 2px solid #000;
    /* Black border for all cells */
    text-align: center;
    padding: 8px;
  }

  .bordered-table thead th {
    background-color: #f5f5f5;
    /* Header background */
    font-weight: bold;
  }

  .radio-bold {
    font-weight: bold;
    font-size: 16px;
  }

  .highlight-row {
    background-color: #b2ebf2 !important;
  }

  .text-center {
    text-align: center;
    color: #757575;
    font-style: italic;
  }

  .center-screen {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 300px;
    /* Adjust height of the div */
    width: 100%;
    /* Full width */
    text-align: center;
  }

  .img-size {
    max-width: 300px;
    /* Width of the image */
    max-height: 700px;
    /* Height of the image */
    object-fit: contain;
  }

  .edit-v-icon {
    padding-left: 6px;
    font-size: 28;
  }

  .edit-v-icon:hover {
    color: white;
  }
</style>